module.exports = __webpack_public_path__ + "img/CI3.541bfd74.png";